import { isValid } from 'date-fns'
import { charityStatusMap } from '../../../../lib/charity'
import { localDate } from '../../../../lib/date'
import { charityValueMap, schemeMap } from './charity'
import { campaignRunningStateMap } from './charityCampaignMap'

export function isDate(key: string, value: string | number): boolean {
  const lowerKey = key.toLowerCase()

  if (
    lowerKey.includes('time') ||
    lowerKey.includes('date') ||
    lowerKey.includes('created') ||
    lowerKey.includes('updated')
  ) {
    return isValid(new Date(value))
  }

  return false
}

export function getReadableValue(key: string, value: string): string {
  if (isDate(key, value)) {
    return localDate(value)
  }

  return (
    charityStatusMap[value as CharityStatusType] ||
    charityValueMap[value as keyof CharityType] ||
    schemeMap[value] ||
    campaignRunningStateMap[value as CampaignRunStateType] ||
    value ||
    '-'
  )
}
